<template>
	<div class="app--engagement-loader"><app-icon value="spinner"></app-icon></div>
</template>
<script>
    export default {}
</script>
